module.exports = __webpack_public_path__ + "static/media/speaker.5d0ec8cb.svg";